module.exports = __webpack_public_path__ + "static/media/video.d547072.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video/video.mp4
// module id = u+NX
// module chunks = 0